module.exports = __webpack_public_path__ + "d59b7cb603c21eacf90291be5735f2d9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-20.png
// module id = 2046
// module chunks = 0